import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import BlogSearch from "./blog-search"
import Newsletter from "./newsletter"
import logo from "../images/logo-brokalia.svg"
import imgNewsletter from "../images/dibus/sidebar-newsletter.svg"
import imgLogoConnect from "../images/logo-connect.svg"
import imgMrUmbrella from "../images/dibus/mister-umbrella.svg"
import { StaticImage } from "gatsby-plugin-image"

const BlogSidebar = props => {
  // console.log(props);

  const getData = graphql`
    {
      allWpCategory {
        distinct(field: {id: SELECT})
        nodes {
          id
          slug
          name
          count
          description
        }
      }
    }
  `
  const data = useStaticQuery(getData)
  const categoryList = data.allWpCategory.nodes

  return (
    <section className="blog-sidebar">
      <BlogSearch />

      <div className="sidebar-widget sidebar-banner">
        <img src={logo} className="sidebar-logo" alt="Logo brokalia" />
        <h3 className="sidebar-title">
          La Correduría de los Administradores de fincas
        </h3>
        <p>Descubre todas las ventajas por colaborar con brokalia.</p>
        <Link className="btn btn-accent" title="Empieza ahora" to="/landing/">
          Empieza ahora
        </Link>
      </div>

      <div className="sidebar-widget sidebar-newsletter">
        <h3 className="sidebar-title">Suscríbete a nuestra Newsletter</h3>
        <div className="flex-between">
          <p>
            No te pierdas <strong>las últimas novedades del sector de la administración de fincas</strong>. ¡Apúntate
            a nuestra newsletter! :)
          </p>
          <img
            src={imgNewsletter}
            className="img-newsletter"
            alt="Suscríbete"
          />
        </div>
        <Newsletter />
      </div>

      <div className="sidebar-widget sidebar-categorias">
        <h3 className="sidebar-title">Categorias</h3>

        <ul className="sidebar-list">
          {categoryList.map((cat, index) => {
            if (cat.count > 0) {
              return (
                <li
                  key={index}
                  className={`sidebar-list-item ${cat.id === props.category ? "active" : ""
                    }`}
                >
                  <Link to={`/${cat.slug}/`}>{cat.name}</Link>
                </li>
              )
            } else {
              return ""
            }
          })}
        </ul>
      </div>

      <div className="sidebar-widget sidebar-experto">
        <h3 className="sidebar-title">El Rincón del Experto</h3>
        <p>
          En esta sección, expertos colegiados resuelven a nuestros lectores cuestiones relativas a la administración de fincas.
        </p>
        <Link title="Empieza ahora" to="/rincon-del-experto/">
          <StaticImage
            src="../images/rincon-experto.jpg"
            alt="Rincón del experto"
            placeholder="blurred"
            layout="constrained"
            width={600}
          />
        </Link>
      </div>

      <div className="sidebar-widget sidebar-connect">
        <img src={imgLogoConnect} className="logo-connect" alt="Brokalia connect" />

        <h1 className="sidebar-title">Gestión integral de siniestros, incluso los no cubiertos</h1>
        <div className="row">
          <div className="col-md-6 bloque-main">
            <p>Ahora en Brokalia, te acompañamos en todo momento. Gestiona, supervisa y repara siniestros no cubiertos con la misma facilidad y confianza.</p>
          </div>
          <div className="col-md-6">
            <img src={imgMrUmbrella} className="img-responsive" alt="Imagen paraguas" />
          </div>
        </div>
        <Link
          className="btn btn-accent"
          title="Planifica una demo"
          to="/connect/"
        >
          Saber más
        </Link>
      </div>


    </section>
  )
}

export default BlogSidebar

//                 <div className="sidebar-widget sidebar-etiquetas">
//     <h3 className="sidebar-title">Etiquetas</h3>
//     <div className="tag-container">
//         {data.allWpPost.edges.map(sidebar => (
//             !sidebar.node.tags ? '' :
//             sidebar.node.tags.map(tag => {
//                 tag_data.push(tag.name);
//                 tag_data = uniq(tag_data);
//                 tag_slug.push(tag.slug);
//                 tag_slug = uniq(tag_slug);

//                 return ''
//             })
//         ))}

//         {join(tag_data, tag_slug).map((e, index) => (
//             <Link key={index} to={`/tag/${e[1]}`} className="btn-tag">{e[0]}</Link>
//         ))}
//     </div>
// </div>
